import React from 'react'
import IconoSimulador from 'assets/images/app/simulador_icon.png'
import IconoCarga from 'assets/images/app/carga_financiera_icon.png'
import IconoImpuestoGlobal from 'assets/images/app/impuesto_global_icon.png'
import { useNavigate } from 'react-router-dom'
import Card from './Card'

const Selector = () => {
  const navigate = useNavigate()
  return (
    <div className="flex flex-col items-center justify-center space-y-3 md:space-y-0 md:space-x-6 md:flex-row">
      <Card
        title="Simulador de crédito"
        subtitle="hipotecario"
        buttonText="¿Cuánto puedo pedir?"
        icon={IconoSimulador}
        navigate={navigate}
        path="/simulador"
      />
      <Card
        title="Simulador de carga"
        subtitle="financiera"
        buttonText="¿Cuánto me alcanza?"
        icon={IconoCarga}
        navigate={navigate}
        path="/carga-financiera"
      />
      <Card
        title="Impuesto Global"
        subtitle="complementario"
        buttonText="¿Cuánto debo pagar?"
        icon={IconoImpuestoGlobal}
        navigate={navigate}
        path="/impuesto-global-complementario"
      />
    </div>
  )
}

export default Selector
